import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addDocument = (token, document) => {
  const config = configurationForToken(token);
  const { name, expirationDate, vehicleId, doc } = document;
  const formData = new FormData();
  formData.append("doc", doc);
  formData.append("name", name);
  formData.append("expirationDate", expirationDate);
  return apiClient.post(`/admin/vehicle/${vehicleId}/document`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: config.headers.Authorization,
    },
  });
};

const allDocuments = (token, vehicleId) => {
  const config = configurationForToken(token);
  return apiClient.get(`/admin/vehicle/${vehicleId}/documents`, config);
};

const editDocument = (token, document) => {
  const config = configurationForToken(token);
  const { id, name, expirationDate, doc } = document;
  const formData = new FormData();
  if (doc) formData.append("doc", doc);
  formData.append("name", name);
  formData.append("expirationDate", expirationDate);
  return apiClient.put(`/admin/vehicle/document/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: config.headers.Authorization,
    },
  });
};

const deleteDocument = (token, documentId) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/vehicle/document/${documentId}`, config);
};

export default {
  addDocument,
  allDocuments,
  editDocument,
  deleteDocument,
};



// WEBPACK FOOTER //
// ./src/Services/DocumentService.js